import { render } from "./TreeSelect.vue?vue&type=template&id=64087c5b&scoped=true"
import script from "./TreeSelect.vue?vue&type=script&lang=js"
export * from "./TreeSelect.vue?vue&type=script&lang=js"

import "./TreeSelect.vue?vue&type=style&index=0&id=64087c5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64087c5b"]])

export default __exports__